<!-- Body Content-->
<div class="md:pt-3 pt-2 md:px-4 px-3 pb-8 mb-6">
  <h1 class="text-base md:text-base md:text-lg text-900 flex align-items-center mb-0 line-height-1" data-testid="create-campaign-header">
    {{'CAMPAIGN.NEW_ANIMATION' | translate }} 
    <i class="fa fa-circle-question text-xl text-600 cursor-pointer ml-2" 
       pTooltip="This is a sample!" 
       tooltipStyleClass="text-xs"
       aria-label="campaign-help-tooltip"
       data-testid="campaign-help-tooltip"></i>
  </h1>
  <div class="mt-1 mb-3">
    <app-breadcrumb></app-breadcrumb>
  </div> 

  <form [formGroup]="createCampaignForm">
      <!-- Card -->
      <div class="surface-0 shadow-2 border-round p-3 text-sm mt-3 relative">
          <!-- Form Group -->
          <div class="mb-3">
              <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="campaign-name-label">{{'SEND_EMAIL.CAMPAIGN_NAME' | translate }}</label>
              <input type="text" 
                     formControlName="campaign_name" 
                     class="text-sm w-full" 
                     pInputText 
                     [placeholder]="'SEND_EMAIL.NAME_PLACEHOLDER' | translate"
                     [ngClass]="{ 'ng-invalid ng-dirty': CampaignNameFormControl.invalid && CampaignNameFormControl.touched }"
                     aria-label="campaign-name-input"
                     data-testid="campaign-name-input" />
              <app-error-msg 
                *ngIf="CampaignNameFormControl.touched && CampaignNameFormControl.invalid" 
                [errors]="CampaignNameFormControl.errors" 
                [fieldLabel]="'SEND_EMAIL.CAMPAIGN_NAME_ERROR' | translate"
                data-testid="campaign-name-error"> 
              </app-error-msg>
          </div>

          <!-- Form Group -->
          <div class="mb-3">
              <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="campaign-description-label">{{'SEND_EMAIL.CAMPAIGN_DESCRIPTION' | translate }}</label>
              <textarea pTextarea 
                        formControlName="campaign_description" 
                        class="w-full h-4rem" 
                        [placeholder]="'SEND_EMAIL.DESC_PLACEHOLDER' | translate"
                        [ngClass]="{ 'ng-invalid ng-dirty': CampaignDescriptionFormControl.invalid && CampaignDescriptionFormControl.touched }"
                        aria-label="campaign-description-input"
                        data-testid="campaign-description-input"></textarea>
              <app-error-msg 
                *ngIf="CampaignDescriptionFormControl.touched && CampaignDescriptionFormControl.invalid" 
                [errors]="CampaignDescriptionFormControl.errors" 
                [fieldLabel]="'SEND_EMAIL.CAMPAIGN_DESCRIPTION_ERROR' | translate"
                data-testid="campaign-description-error">
              </app-error-msg>
          </div>

         <!-- Form Group -->
         <div *ngIf="false">
            <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="tenant-selection-label">{{'CAMPAIGN.ADD_TENANTS' | translate }}</label>
            <p-treeSelect
                class="w-full text-sm"
                containerStyleClass="w-full text-sm"
                [options]="tenants"
                placeholder="Select..."
                formControlName="selected_tenant"
                selectionMode="checkbox" 
                [filter]="true" 
                [filterInputAutoFocus]="true"
                [ngClass]="{ 'ng-invalid ng-dirty': SelectedTenantsFormControl.invalid && SelectedTenantsFormControl.touched }"
                aria-label="tenant-selection-dropdown"
                data-testid="tenant-selection-dropdown">
            </p-treeSelect>
        </div>
      </div>

      <!-- Card -->
      <div class="surface-0 shadow-2 border-round text-sm mt-3">
          <!-- Card Header -->
          <div class="flex align-items-center justify-content-between py-2 px-3 cursor-pointer border-bottom-1 border-300" 
               (click)="showActionGroup1=!showActionGroup1"
               aria-label="toggle-action-group"
               data-testid="toggle-action-group">
            <div class="flex align-items-center">
              <div class="bg-primary border-round-3xl font-bold text-center text-xs py-2 px-4 mr-3" data-testid="add-group-label">{{'CAMPAIGN.ADD_GROUP' | translate }}</div>
              <p-datepicker
                [showIcon]="true"
                formControlName="campaign_action_date"
                icon="fa fa-calendar font-light"
                dateFormat="M dd,yy"
                [yearNavigator]="true"
                yearRange="2023:2030"
                [placeholder]="'SEND_EMAIL.CHOOSE_DATE' | translate"
                inputStyleClass="text-sm w-6rem md:w-10rem"
                [minDate]="minDate"
                [maxDate]="maxDate"
                [ngClass]="{ 'ng-invalid ng-dirty': CampaignActionDateFormControl.invalid && CampaignActionDateFormControl.touched }"
                (click)="$event.stopPropagation()"
                (onShow)="$event.stopPropagation()"
                (onFocus)="$event.stopPropagation()"
                aria-label="campaign-action-date-input"
                data-testid="campaign-action-date-input">
              </p-datepicker>  
              <app-error-msg 
                *ngIf="CampaignActionDateFormControl.touched && CampaignActionDateFormControl.invalid" 
                [errors]="CampaignActionDateFormControl.errors" 
                [fieldLabel]="'SEND_EMAIL.SCHEDULE_DATE' | translate"
                data-testid="campaign-action-date-error">
              </app-error-msg>
            </div>
            <i class="fa text-primary ml-2" 
               [ngClass]="showActionGroup1 ? 'fa-chevron-circle-up' : 'fa-chevron-circle-down'"
               aria-label="toggle-action-group-icon"
               data-testid="toggle-action-group-icon"></i>
          </div>

          <!-- Card Body -->
          <div *ngIf="showActionGroup1">
            <div class="mb-3 p-3">
                <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CAMPAIGN.PRESET_CAMPAIGNS' | translate }}</label>
                <p-select 
                  [options]="campaignGroups" 
                  [(ngModel)]="selectedCampaign" 
                  [group]="true"
                  [filter]="true"
                  filterBy="label,category"
                  [showClear]="true"
                  [placeholder]="'CAMPAIGN.PLACE_HOLDER_PRESET_CAMPAIGNS' | translate"
                  [filterPlaceholder]="'CAMPAIGN.PLACEHOLDER_SEARCH' | translate"
                  styleClass="mt-2 w-full"
                  panelStyleClass="w-full md:w-auto"
                  [ngModelOptions]="{standalone: true}"
                  (onClear)="clearCampaign()"
                  (onChange)="onCampaignSelect($event)">
                    <ng-template pTemplate="group" let-group>
                        <div class="flex align-items-center justify-content-between surface-100 py-2 px-3 mb-1 w-full">
                            <div class="flex align-items-center">
                                <i class="pi pi-tag mr-2 text-primary"></i>
                                <span class="font-semibold text-900">{{group.label}}</span>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="item" let-item>
                        <div class="flex align-items-center w-full px-3 py-2">
                            <div class="flex flex-column w-full">
                                <span class="text-sm font-medium text-700 white-space-normal">{{item.label}}</span>
                                <small class="text-xs text-500 white-space-normal" *ngIf="item.description">{{item.description}}</small>
                            </div>
                        </div>
                    </ng-template>
                </p-select>
              </div>

              <div class="mb-3 p-3">
                <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="campaign-rule-label">{{'CAMPAIGN.RULE' | translate }}</label>
                <query-builder 
                  [tenantId]="tenantId" 
                  [eventType]="eventType" 
                  (rule)="getRule($event)" 
                  [query]="sqlRule.value"
                  aria-label="campaign-rule-builder"
                  data-testid="campaign-rule-builder">
                </query-builder>
              </div>

              <div class="surface-100 p-3">
                  <p-button 
                    icon="fa fa-chevron-down" 
                    label="Add Actions" 
                    iconPos="right" 
                    styleClass="text-sm" 
                    (click)="addActions.toggle($event)"
                    aria-label="add-actions-button"
                    data-testid="add-actions-button">
                    <i class="fa fa-plus-circle mr-2"></i>
                  </p-button>

                  <p-popover #addActions styleClass="overflow-hidden right-0 text-sm w-12rem">
                      <ng-template #content>
                          <ul class="list-none -m-2 px-0 text-xs font-bold">
                              <li class="flex align-items-center my-1" *ngFor="let action of Actions">
                                  <p-checkbox 
                                    checkboxIcon="fa fa-check" 
                                    [binary]="true" 
                                    [formControlName]="'selectedAction_'+action.key" 
                                    [value]="action.key" 
                                    [inputId]="action.key" 
                                    (onChange)="ToggleActions($event, action.key)"
                                    [attr.aria-label]="'select-action-checkbox-' + action.key"
                                    [attr.data-testid]="'select-action-checkbox-' + action.key">
                                  </p-checkbox>
                                  <label [for]="action.key" class="cursor-pointer ml-2" [attr.data-testid]="'action-label-' + action.key">{{ 'CAMPAIGN.TABLE.'+action.text | translate }}</label>
                              </li>
                          </ul>
                      </ng-template>
                  </p-popover>

                  <!-- Table -->
                  <div *ngIf="showTable" class="mt-3 surface-0 shadow-2 border-round mb-2">
                      <p-table [value]="ActionTableData" responsiveLayout="scroll">
                          <ng-template pTemplate="header">
                              <tr>
                                  <th class="text-xs text-600" data-testid="actions-column-header">{{'CAMPAIGN.ACTIONS' | translate }}</th>
                                  <th class="text-xs text-600" data-testid="config-status-column-header">{{'CAMPAIGN.CONFIGURATION_STATUS' | translate }}</th>
                                  <th class="text-xs text-600"></th>
                              </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-tableData>
                              <tr class="text-sm">
                                  <td class="py-2 relative white-space-nowrap border-left-3 border-{{tableData.color}} border-top-none px-0">
                                      <div class="flex align-items-center text-{{tableData.color}} px-3" [attr.data-testid]="'action-name-' + tableData.key">
                                          <i class="{{tableData.icon}} mr-2"></i>
                                          <strong>{{ 'CAMPAIGN.TABLE.'+tableData.text | translate }}</strong>
                                      </div>
                                      <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none m-0 absolute left-0 bottom-0 w-full" />
                                  </td>
                                  <td class="py-2 relative white-space-nowrap border-top-none px-0">
                                      <div class="px-3" [attr.data-testid]="'action-status-' + tableData.key">{{tableData.status}}</div>
                                      <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none m-0 absolute left-0 bottom-0 w-full" />
                                  </td>
                                  <td class="py-2 relative white-space-nowrap border-top-none px-0 text-right">
                                      <div class="px-3 flex align-items-center justify-content-end gap-2">
                                          <p-button 
                                            label="Configure" 
                                            icon="fa fa-gear" 
                                            styleClass="p-button-outlined text-sm hidden md:inline-block" 
                                            (click)="configureActions(tableData.key)"
                                            [attr.aria-label]="'configure-action-' + tableData.key"
                                            [attr.data-testid]="'configure-action-' + tableData.key">
                                          </p-button>
                                          <p-button 
                                            icon="fa fa-gear" 
                                            styleClass="p-button-outlined md:hidden" 
                                            (click)="configureActions(tableData.key)"
                                            [attr.aria-label]="'configure-action-mobile-' + tableData.key"
                                            [attr.data-testid]="'configure-action-mobile-' + tableData.key">
                                          </p-button>
                                          <button 
                                            class="p-button p-button-text p-button-danger" 
                                            (click)="removeAction(tableData.key)"
                                            [attr.aria-label]="'remove-action-' + tableData.key"
                                            [attr.data-testid]="'remove-action-' + tableData.key">
                                              <i class="fa fa-times"></i>
                                          </button>
                                      </div>
                                      <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none m-0 absolute left-0 bottom-0 w-full" />
                                  </td>
                              </tr>
                          </ng-template>
                      </p-table>
                  </div>
              </div>
          </div>
      </div>

      <!-- Buttons -->
      <div class="flex align-items-center justify-content-between mt-3 pt-2">
          <p-button 
            [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate" 
            (onClick)="CancelCampaign()" 
            styleClass="p-button-text text-sm"
            aria-label="cancel-campaign-button"
            data-testid="cancel-campaign-button">
          </p-button>
          <p-button 
            [label]="'CAMPAIGN.BTN_SAVE' | translate" 
            [disabled]="!createCampaignForm.valid" 
            [loading]="btnLoading" 
            (click)="CreateCampaign()" 
            styleClass="text-sm"
            aria-label="save-campaign-button"
            data-testid="save-campaign-button">
          </p-button>
      </div>
  </form>
</div>

<!-- Child Components -->
<create-opportunity 
  *ngIf="showCreateOpportunityPopup" 
  [visible]="showCreateOpportunityPopup" 
  (hidePopup)="hideOpportunity($event)"
  aria-label="create-opportunity-popup"
  data-testid="create-opportunity-popup">
</create-opportunity>

<send-bulk-email 
  *ngIf="showBulkEmailPopup" 
  [visible]="showBulkEmailPopup" 
  [tenantId]="tenantId"
  [EmailSendType]="EmailSendType" 
  [CampaignSource]="campaignSource" 
  [actionPayload]="getEmailActipnPayload"
  (hide)="HideSendEmail($event)"
  aria-label="send-bulk-email-popup"
  data-testid="send-bulk-email-popup">
</send-bulk-email>

<send-bulk-sms 
  *ngIf="showBulkSmsPopup" 
  [visible]="showBulkSmsPopup" 
  [tenantId]="tenantId"
  [SMSSendType]="SMSSendType" 
  [CampaignSource]="campaignSource"  
  [actionPayload]="getSmsActipnPayload"
  (hide)="HideSMSEmail($event)"
  aria-label="send-bulk-sms-popup"
  data-testid="send-bulk-sms-popup">
</send-bulk-sms>

<send-whatsapp 
  *ngIf="showBulkWhatsAppPopup" 
  [visible]="showBulkWhatsAppPopup" 
  [tenantId]="tenantId"
  [WhatsAppSendType]="WhatsAppSendType" 
  [CampaignSource]="campaignSource"  
  [actionPayload]="getWhatsappActipnPayload"
  (hide)="HideWhatsAppPopup($event)"
  aria-label="send-whatsapp-popup"
  data-testid="send-whatsapp-popup">
</send-whatsapp>

<task-create 
  *ngIf="showTaskCreate" 
  [visible]="showTaskCreate" 
  [TaskCreateType]="taskCreateType" 
  [CampaignSource]="campaignSource" 
  [actionPayload]="getTaskActipnPayload"
  (hide)="hideTaskCreate($event)"
  aria-label="task-create-popup"
  data-testid="task-create-popup">
</task-create>

<!-- Amount Spender Modal -->
<p-dialog *ngIf="showAmountSpenderPopup" [(visible)]="showAmountSpenderPopup" [resizable]="false" appendTo="body" [modal]="true" [closeOnEscape]="true"
  (onHide)="closeDialogEvent()" [breakpoints]="{'767px': '100vw'}" [style]="{width: '670px'}"
  styleClass="no-header-modal">

  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Header -->
    <div class="sticky left-0 top-0 z-1 surface-0 py-3 px-4 flex align-items-center justify-content-between border-bottom-1 border-300">
      <h2 class="mb-0 text-sm">{{'CAMPAIGN.HIGH_SPENDERS' | translate}}</h2>
      <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="closeDialogEvent()"></div>
    </div>
    <!-- Header -->

    <form [formGroup]="amountSpenderForm" (ngSubmit)="addAmountSpender()">
      <!-- Content -->
      <div class="py-3 px-4">
        <!-- Form Group -->
        <div class="mb-3">
          <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CAMPAIGN.AMOUNT_SPENDER' | translate}}</label>
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">{{ currencySymbol$ | async }}</span>
            <p-inputNumber formControlName="amount" [min]="0" [max]="1000000" [step]="1000" 
              mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [useGrouping]="true"
              [showButtons]="false" styleClass="w-full" inputStyleClass="w-full text-sm"
              [ngClass]="{ 'ng-invalid ng-dirty': AmountSpenderFormControl.invalid && AmountSpenderFormControl.touched }">
            </p-inputNumber>
          </div>
          <app-error-msg *ngIf="AmountSpenderFormControl.dirty && AmountSpenderFormControl.invalid" 
            [errors]="AmountSpenderFormControl.errors" [fieldLabel]="'CAMPAIGN.AMOUNT_SPENDER' | translate">
          </app-error-msg>
        </div>
        <!-- Form Group -->
      </div>
      <!-- Content -->

      <!-- Modal Footer -->
      <div class="sticky left-0 bottom-0 z-1 surface-0 flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300">
        <p-button type="button" [label]="'CLIENT_PROFILE.KYE_FOB.CANCEL' | translate"
          styleClass="p-button-text text-sm" (click)="closeDialogEvent()">
        </p-button>
        <p-button type="submit" [label]="'CAMPAIGN.BTN_ADD' | translate" 
          [loading]="btnLoading" [disabled]="amountSpenderForm.invalid" styleClass="text-sm">
        </p-button>
      </div>
      <!-- Modal Footer -->
    </form>

  </ng-template>
</p-dialog>
<!-- Amount Spender Modal -->

<!-- Child Components -->


